function scroll2() {
    var link = $('._js-scroll-link');

    link.on('click',function(e){
        e.preventDefault();
        $('body').scrollTo(this.hash, this.hash);
    });
}